import {Tabs, Loader} from "@mantine/core";
import {useTranslation} from "react-i18next";
import IconKaiChat from "../../../assets/kai-chat-logo.svg?react";
import IconCheck from "../../../assets/check.svg?react";
import IconSearch from "../../../assets/search.svg?react";
import classes from "./ThreadTabs.module.css";

export type ThreadTabKey = "answer" | "tools" | "sources";

interface ThreadTabsProps {
    active: ThreadTabKey;
    onChange: (tab: ThreadTabKey) => void;
    toolsCount: number;
    sourcesCount: number;
    searchLoading: boolean;
    showToolsTab: boolean;
    showSourcesTab: boolean;
    showAnswerBadge: boolean;
}

export const ThreadTabs = ({
    active,
    onChange,
    toolsCount,
    sourcesCount,
    searchLoading,
    showToolsTab,
    showSourcesTab,
    showAnswerBadge,
}: ThreadTabsProps) => {
    const {t} = useTranslation();

    const countPill = (count: number) => (
        <span className={classes.countPill}>
            {searchLoading ? (
                <Loader type="dots" size="xs" color="gneis.5" />
            ) : (
                count
            )}
        </span>
    );

    return (
        <Tabs
            value={active}
            onChange={(val) => val && onChange(val as ThreadTabKey)}
            variant="default"
            classNames={{
                root: classes.root,
                list: classes.list,
                tab: classes.tab,
                tabLabel: classes.tabLabel,
            }}
        >
            <Tabs.List>
                <Tabs.Tab
                    value="answer"
                    leftSection={
                        <IconKaiChat
                            width={16}
                            height={16}
                            className={classes.tabIcon}
                        />
                    }
                    rightSection={
                        showAnswerBadge ? (
                            <span
                                className={classes.answerBadge}
                                aria-label={t("thread.tabs.answerReady", {
                                    defaultValue: "Answer ready",
                                })}
                            >
                                <IconCheck
                                    width={10}
                                    height={10}
                                    className={classes.answerBadgeIcon}
                                />
                            </span>
                        ) : null
                    }
                >
                    {t("thread.tabs.answer", {defaultValue: "Svar fra KAI"})}
                </Tabs.Tab>
                {showToolsTab && (
                    <Tabs.Tab
                        value="tools"
                        leftSection={
                            <IconSearch
                                width={14}
                                height={14}
                                className={classes.searchTabIcon}
                            />
                        }
                        rightSection={countPill(toolsCount)}
                    >
                        {t("thread.postsearch.filters.tools", {
                            defaultValue: "Verktøy",
                        })}
                    </Tabs.Tab>
                )}
                {showSourcesTab && (
                    <Tabs.Tab
                        value="sources"
                        leftSection={
                            <IconSearch
                                width={14}
                                height={14}
                                className={classes.searchTabIcon}
                            />
                        }
                        rightSection={countPill(sourcesCount)}
                    >
                        {t("thread.postsearch.filters.otherSources", {
                            defaultValue: "Kilder",
                        })}
                    </Tabs.Tab>
                )}
            </Tabs.List>
        </Tabs>
    );
};
